export const tr = {
  // Common
  loading: "Yükleniyor...",
  back: "Geri",
  cancel: "İptal",
  submit: "Gönder",
  create: "Oluştur",
  delete: "Sil",
  edit: "Düzenle",
  save: "Kaydet",
  confirm: "Onayla",
  logout: "Çıkış Yap",
  login: "Giriş Yap",
  optional: "İsteğe bağlı",
  deleting: "Siliniyor...",
  
  // Operating Ledger Delete
  deleteLedgerEntryTitle: "Kaydı Sil",
  deleteLedgerWarning: "Bu işlem geri alınamaz. Tüm ilgili mali veriler güncellenecektir.",
  entryType: "Tür",
  documentNo: "Belge No",
  amount: "Tutar",
  voidReason: "Silme Nedeni",
  enterVoidReason: "Silme nedenini giriniz...",
  
  // Operating Ledger namespace
  operatingLedger: {
    deleteSuccess: "Kayıt başarıyla silindi",
    deleteError: "Kayıt silinirken hata oluştu"
  },
  
  // Landing Page
  appTitle: "Bina Yönetim Sistemi",
  appSubtitle: "Apartman yönetimini kolaylaştırın, aidat ödemelerini takip edin, harcamaları izleyin ve sakinleri bilgilendirin.",
  signInGoogle: "Google ile Giriş Yap",
  signInManual: "Kullanıcı Adı ile Giriş Yap",
  apartmentManagement: "Apartman Yönetimi",
  apartmentManagementDesc: "Daireleri kolayca yönetin ve sakinleri atayın",
  feeTracking: "Aidat Takibi",
  feeTrackingDesc: "Aidat ödemelerini ve durumunu takip edin",
  announcements: "Duyurular",
  announcementsDesc: "Sakinleri güncellemelerle bilgilendirin",
  
  // PandaProp Landing Page
  landingLogoAlt: "PandaProp Logosu",
  landingTitle: "PandaProp",
  landingSubtitle: "Tam Kapsamlı Bina & Apartman Yönetimi",
  landingDescription: "Daireler, aidatlar, giderler, yatırımlar, diğer gelirler, duyurular ve mali raporları tek bir çok kiracılı platformda yönetin.",
  landingPrimaryCta: "Giriş Yap",
  landingLoginHint: "Atanmış kullanıcı adı ve şifrenizi kullanın",
  
  // Feature Cards
  featureApartments: "Daire & Sakin Yönetimi",
  featureApartmentsDesc: "Katları, daireleri ve sakin atamalarını kolayca yönetin",
  featureDues: "Aidat Takibi & Ödemeler",
  featureDuesDesc: "Ödenen/ödenmemiş durumunu detaylı aylık raporlarla takip edin",
  featureExpenses: "Gider Yönetimi",
  featureExpensesDesc: "Bina giderlerini türe göre kategorize edin ve takip edin",
  featureInvestments: "Yatırım Takibi",
  featureInvestmentsDesc: "Bina projelerini ve sermaye yatırımlarını izleyin",
  featureOtherIncome: "Diğer Gelirler",
  featureOtherIncomeDesc: "Kira geliri, ücretler ve çeşitli gelirleri takip edin",
  featureAnnouncements: "Duyurular",
  featureAnnouncementsDesc: "Sakinleri bina genelinde güncellemelerle bilgilendirin",
  
  // Trust Bullets
  bulletMultiTenancy: "Bina bazlı çok kiracılı yapı",
  bulletAdminResident: "Yönetici & Sakin portalları",
  bulletMonthlyReports: "Aylık mali özet & detaylı raporlar",
  
  // Login Form
  username: "Kullanıcı Adı",
  password: "Şifre",
  usernameRequired: "Kullanıcı adı gerekli",
  passwordRequired: "Şifre gerekli",
  invalidCredentials: "Geçersiz kullanıcı adı veya şifre",
  
  // Dashboard
  adminDashboard: "Yönetici Paneli",
  residentPortal: "Sakin Portalı",
  totalCollected: "Toplam Tahsilat",
  totalUnpaid: "Toplam Ödenmemiş",
  totalExpenses: "Toplam Giderler",
  viewOperatingLedger: "İşletme Hesabı Defterini Görüntüle",
  close: "Kapat",
  
  // Operating Ledger
  operatingLedgerTitle: "İşletme Hesabı Defteri",
  selectMonthYear: "Ay/Yıl Seçin",
  year: "Yıl",
  month: "Ay",
  apply: "Uygula",
  buildingName: "Apartman Adı",
  ledgerRowNo: "Sıra",
  ledgerDate: "Tarih",
  ledgerDocNo: "Belge No",
  ledgerInvoiceNo: "Fatura No",
  ledgerInvoiceNoPlaceholder: "Fatura no girin",
  ledgerDescription: "Açıklama",
  ledgerExpenses: "Giderler",
  ledgerGoodsPurchases: "Mal Alışlar",
  ledgerPaidVAT: "Ödenen KDV",
  ledgerIncome: "Gelirler",
  ledgerGoodsSales: "Mal Satışlar",
  ledgerCollectedVAT: "Tahsil KDV",
  ledgerBalance: "Bakiye",
  ledgerTotal: "Toplam",
  ledgerGrandTotal: "Yekün Toplamı",
  ledgerMaintenanceCollection: "Aidat Tahsilatı",
  ledgerOtherIncome: "Diğer Gelir",
  ledgerNoRecords: "Bu dönem için kayıt yok",
  ledgerUnit: "Daire",
  ledgerDevirBanka: "Devir Banka",
  
  // Bank Statement Upload
  loadBankStatement: "Banka Ekstresi Yükle",
  bankStatementResults: "Banka Ekstresi Analizi",
  uploadExcelFile: "Excel dosyası yükleyin (.xls veya .xlsx)",
  selectFile: "Dosya Seç",
  analyzing: "Analiz ediliyor...",
  aidatPayments: "Aidat Ödemeleri",
  otherPaymentsSection: "Diğer Ödemeler (Kapıcı Tazminatı vb.)",
  expensesSection: "Giderler",
  unidentifiedTransactions: "Tanımlanamayan İşlemler",
  totalAmount: "Toplam Tutar",
  transactionCount: "İşlem Sayısı",
  apartmentsFound: "Bulunan Daireler",
  residentName: "Sakin Adı",
  periodLabel: "Dönem",
  noTransactionsFound: "İşlem bulunamadı",
  parseError: "Dosya okunamadı",
  
  // Bank Statement - Unit Assignment & Posting
  assignUnit: "Daire Ata",
  selectUnit: "Daire Seç",
  poolAccount: "Havuz Hesabı",
  postToOperatingLedger: "İşletme Defterine Kaydet",
  confirmPostTitle: "Kayıtları Onayla",
  confirmPostMessage: "Seçilen işlemleri işletme hesabı defterine kaydetmek istediğinizden emin misiniz?",
  posting: "Kaydediliyor...",
  postingComplete: "Kayıt Tamamlandı",
  postingFailed: "Kayıt Başarısız",
  bankStatementPosted: "Banka ekstresi başarıyla kaydedildi",
  transactionsProcessed: "İşlenen İşlem",
  assignedToUnits: "Dairelere Atanan",
  assignedToPool: "Havuza Atanan",
  expensesPosted: "Gider Kaydı",
  failedTransactions: "Başarısız İşlemler",
  
  // Bank Statements Page
  bankStatementsTitle: "Banka Ekstreleri",
  bankStatementsNav: "Banka Ekstreleri",
  uploadedStatements: "Yüklenen Ekstreler",
  noStatementsYet: "Henüz banka ekstresi yüklenmedi",
  uploadNewStatement: "Yeni Ekstre Yükle",
  statementFilename: "Dosya Adı",
  statementUploadDate: "Yükleme Tarihi",
  statementPostDate: "Kayıt Tarihi",
  statementStatus: "Durum",
  statementUploaded: "Yüklendi",
  statementPosted: "Kaydedildi",
  viewDetails: "Detaylar",
  revertStatement: "Geri Al",
  deleteStatement: "Sil",
  revertConfirmTitle: "Banka Ekstresini Geri Al",
  revertConfirmMessage: "Bu banka ekstresini geri almak istediğinizden emin misiniz? Bu işlem, bu ekstreden oluşturulan TÜM kayıtları silecek (giderler, ödemeler, havuz hareketleri). Bu işlem geri alınamaz.",
  revertInProgress: "Geri alınıyor...",
  revertSuccess: "Banka ekstresi başarıyla geri alındı",
  revertFailed: "Geri alma işlemi başarısız",
  deleteConfirmTitle: "Banka Ekstresini Sil",
  deleteConfirmMessage: "Bu banka ekstresini silmek istediğinizden emin misiniz? Bu ekstreyi tekrar kullanmak isterseniz dosyayı yeniden yüklemeniz gerekecek.",
  deleteSuccess: "Banka ekstresi silindi",
  expensesRemoved: "Silinen Gider",
  paymentsRemoved: "Silinen Ödeme",
  poolEntriesRemoved: "Silinen Havuz Kaydı",
  feesRecalculated: "Yeniden Hesaplanan Aidat",
  
  // Maintenance Payment Edit
  editMaintenancePayment: "Aidat Ödemesini Düzenle",
  currentUnit: "Mevcut Daire",
  period: "Dönem",
  assignToUnit: "Daireye Ata",
  updateSuccess: "Güncelleme başarılı",
  paymentReassigned: "Ödeme yeniden atandı",
  sameUnitSelected: "Aynı daire seçildi - değişiklik yapılmadı",
  
  // Pool Income
  poolIncome: "Havuz Hesabı Geliri",
  poolIncomeDetails: "Havuz Geliri Detayları",
  poolIncomeNote: "Havuz gelir kayıtları Banka Ekstreleri üzerinden yönetilir. Değiştirmek için banka ekstresini geri alıp yeniden içe aktarın.",
  assignPoolToUnit: "Havuz Gelirini Daireye Ata",
  poolAssignmentNote: "Bu işlem, ödemeyi seçilen dairenin en eski ödenmemiş aidat borçlarına otomatik olarak uygulayacaktır.",
  assignAndApply: "Ata ve Uygula",
  feesUpdated: "aidat güncellendi",
  processing: "İşleniyor...",
  otherPayment: "Diğer Ödeme",
  
  // Document Status (Belge Durumu)
  documentStatusActive: "Aktif",
  documentStatusVoid: "İptal",
  documentStatusReversal: "Ters Kayıt",
  voidReason: "İptal Nedeni",
  reversalOf: "Ters Kaydı",
  reversedBy: "İptal Eden",
  voidConfirmTitle: "Kaydı İptal Et",
  voidConfirmMessage: "Bu kaydı iptal etmek istediğinizden emin misiniz? İptal işlemi geri alınamaz ve bir ters kayıt oluşturulacak.",
  voidReasonPlaceholder: "İptal nedenini girin...",
  voidSuccess: "Kayıt başarıyla iptal edildi",
  
  // Edit Expense/Income
  editExpense: "Gideri Düzenle",
  expenseUpdated: "Gider başarıyla güncellendi",
  documentNoImmutable: "değiştirilemez",
  
  // Past month expense warning
  pastMonthExpenseTitle: "Önceki Ay Gideri",
  pastMonthExpenseMessage: "Seçtiğiniz tarih önceki bir aya ait. Bu gider defterde seçilen ayda değil, girdiğiniz tarihin ayında görünecek. Devam etmek istiyor musunuz?",
  pastMonthExpenseCancel: "İptal",
  pastMonthExpenseContinue: "Devam Et",
  
  apartments: "Daireler",
  outstandingBalance: "Ödenmemiş Bakiye",
  totalPaid: "Toplam Ödenen",
  
  // Navigation
  maintenanceFees: "Aidat Ödemeleri",
  expenses: "Giderler",
  expenseReports: "Gider Raporları",
  manageApartments: "Daireleri ve sakinleri yönetin",
  trackPayments: "Ödemeleri takip edin ve yönetin",
  recordExpenses: "Bina giderlerini kaydedin",
  postUpdates: "Sakinler için güncellemeler yayınlayın",
  viewUpdates: "Bina güncellemelerini görüntüleyin",
  seeExpenses: "Aidatların nasıl harcandığını görün",
  
  // Sample Data
  generateSampleData: "Örnek Veri Oluştur",
  generateSampleDataDesc: "Demo için test verisi oluştur",
  clearSampleData: "Örnek Veriyi Temizle",
  clearSampleDataDesc: "Tüm test verisini kaldır",
  sampleDataGenerated: "Örnek veri oluşturuldu",
  sampleDataCleared: "Örnek veri temizlendi",
  
  // Apartments
  newApartment: "+ Yeni Daire",
  unitNumber: "Daire No",
  floor: "Kat",
  resident: "Sakin",
  residents: "Sakinler",
  assignResident: "Sakin ata...",
  ownerLabel: "Malik / Ev Sahibi",
  tenantLabel: "Kiracı",
  selectOwner: "Malik seçin...",
  selectTenantOptional: "Kiracı seçin (opsiyonel)...",
  ownerOccupied: "Malik oturuyor",
  tenantOccupied: "Kiracılı",
  ownerTenantHint: "Aidat kiracıya, diğer ödemeler malike atanır.",
  occupancyStatus: "Doluluk Durumu",
  ownerRequired: "Malik seçilmelidir.",
  tenantRequired: "Kiracılı dairede kiracı seçilmelidir.",
  samePersonError: "Malik ve kiracı aynı kişi olamaz. Malik evde oturuyorsa kiracı alanını boş bırakın ve 'Malik oturuyor' seçin.",
  assignmentSaved: "Atama kaydedildi",
  tenantDebtReadOnly: "Kiracı borcu (salt okunur)",
  tenantDuesReadOnly: "Kiracı aidat borcu (salt okunur)",
  selectUnit: "Daire seçin",
  totalAllUnits: "Toplam borç (tüm daireler)",
  yourDebtLabel: "Sizin borcunuz",
  residentAssigned: "Sakin atandı",
  apartmentCreated: "Daire oluşturuldu",
  apartmentDeleted: "Daire silindi",
  deleteApartment: "Bu daireyi silmek istediğinizden emin misiniz?",
  noResident: "Sakin yok",
  assigned: "Atandı",
  
  // Maintenance Fees
  newFee: "+ Yeni Aidat",
  amount: "Tutar",
  month: "Ay",
  year: "Yıl",
  status: "Durum",
  actions: "İşlemler",
  period: "Dönem",
  paid: "ödendi",
  unpaid: "ödenmedi",
  partiallyPaid: "kısmi ödendi",
  markPaid: "Ödendi Olarak İşaretle",
  markUnpaid: "Ödenmedi Olarak İşaretle",
  markedAsPaid: "Ödendi olarak işaretlendi",
  markedAsUnpaid: "Ödenmedi olarak işaretlendi",
  
  // Partial Payment System
  takePayment: "Ödeme Al",
  payInFull: "Tamamını Öde",
  partialPayment: "Kısmi Ödeme",
  paidAmount: "Ödenen Tutar",
  remainingAmount: "Kalan Tutar",
  dueAmount: "Borç Tutarı",
  aidatAmount: "Aidat",
  otherPaymentAmount: "Diğer Ödeme",
  paymentAmount: "Ödeme Tutarı",
  paymentMethod: "Ödeme Yöntemi",
  paymentNote: "Ödeme Notu",
  paymentRecorded: "Ödeme kaydedildi",
  cannotMarkUnpaidWithPayments: "Aktif ödeme kayıtları varken ödenmedi olarak işaretlenemez",
  partialPaymentLabel: "Kısmi",
  paymentHistory: "Ödeme Geçmişi",
  noPayments: "Henüz ödeme yapılmadı",
  
  // Simplified Payment Actions
  markAsPaid: "Ödendi İşaretle",
  undoPayment: "Geri Al",
  undoPaymentConfirm: "Bu dönem için tüm ödemeleri geri almak istediğinizden emin misiniz?",
  paymentUndone: "Ödeme(ler) geri alındı",
  confirmPayment: "Ödemeyi Onayla",
  paymentExceedsRemaining: "Ödeme tutarı kalan borçtan fazla olamaz",
  paymentDateYearWarning: "Ödeme tarihi seçilen yıl içinde olmalıdır",
  noApartments: "Daire bulunamadı. Önce daire ekleyin.",
  
  // Cumulative Balance System
  devirBakiyesi: "Devir Bakiyesi",
  cumulativeRemaining: "Kalan (Kümülatif)",
  openingBalance: "Açılış Bakiyesi",
  cumulativeBalance: "Kümülatif Bakiye",
  
  // Initial Carryover System (one-time setup)
  initializeCarryover: "Devir Bakiyesi Başlat",
  initialCarryoverAmount: "Başlangıç Devir Tutarı",
  effectiveYear: "Geçerli Yıl",
  initializeCarryoverHelp: "Bu daire için başlangıç devir bakiyesini bir kez ayarlayın. Bu tutar, izlemenin başladığı yıl için kullanılacaktır. Sonraki yılların devir bakiyesi önceki yıl kapanış bakiyesinden otomatik olarak hesaplanacaktır.",
  carryoverInitialized: "Devir bakiyesi başarıyla ayarlandı",
  carryoverAlreadySet: "Bu daire için devir bakiyesi zaten ayarlanmış. Değiştirilemez.",
  carryoverNotInitialized: "Devir bakiyesi henüz ayarlanmamış",
  carryoverSourceInitial: "Başlangıç tutarı",
  carryoverSourcePreviousYear: "Önceki yıl kapanış bakiyesi",
  positiveIsDebt: "Pozitif = Borç, Negatif = Alacak",
  immutableWarning: "Bu işlem geri alınamaz. Değişiklik yapılamaz.",
  
  // Summary Footer
  total: "TOPLAM",
  totalDebt: "Toplam Borç",
  totalCredit: "Toplam Alacak",
  balance: "Bakiye",
  balanceZero: "Bakiye Sıfır",
  cumulativeAsOfToday: "Seçilen yıl ve bugüne kadar kümülatif",
  monthNotStarted: "Bu ay henüz başlamadı",
  cannotCreateFutureFees: "Gelecek aylar için aidat oluşturulamaz",
  futureMonthsNotCreated: "gelecek ay için aidat oluşturulmadı",
  
  // Advance Payments
  advancePayment: "Avans Ödeme",
  advancePaymentInfo: "Bu ödeme, ilgili ay için avans olarak işlenecektir.",
  advancePaymentAllocated: "Avans ödeme kaydedildi",
  advancePaymentDeleted: "Avans ödeme silindi",
  allocatePayment: "Ödeme Tahsis Et",
  
  // Other Payments (Diğer Ödemeler)
  otherPayments: "Diğer Ödemeler",
  addOtherPayment: "+ Diğer Ödeme",
  otherPaymentSchedule: "Diğer Ödeme Planı",
  startMonth: "Başlangıç Ayı",
  durationMonths: "Kaç Ay Boyunca",
  amountPerMonth: "Aylık Tutar",
  paymentDescription: "Açıklama Detayı",
  paymentDescriptionPlaceholder: "Ödeme açıklaması girin (örn: Tadilat masrafı, Asansör bakımı)",
  otherPaymentCreated: "Diğer ödeme planı oluşturuldu",
  otherPaymentDeleted: "Diğer ödeme planı silindi",
  otherPaymentCollection: "Diğer Ödeme Tahsilatı",
  selectMonth: "Ay seçin...",
  
  feeCreated: "Aidat oluşturuldu",
  feeDeleted: "Aidat silindi",
  deleteFee: "Bu aidatı silmek istediğinizden emin misiniz?",
  apartment: "Daire",
  selectApartment: "Daire seçin...",
  generateYearlyFees: "Yıllık Aidatları Oluştur",
  yearlyFeesGenerated: "Yıllık aidatlar başarıyla oluşturuldu",
  allFeesAlreadyExist: "Bu yıl için tüm aidatlar zaten mevcut",
  created: "oluşturuldu",
  skipped: "atlandı",
  monthlyAmount: "Aylık Tutar",
  all: "Tümü",
  generate: "Oluştur",
  
  // Expenses
  newExpense: "+ Yeni Gider",
  addExpense: "+ Gider Ekle",
  category: "Kategori",
  subcategory: "Alt Kategori",
  date: "Tarih",
  description: "Açıklama",
  expenseCreated: "Gider oluşturuldu",
  expenseDeleted: "Gider silindi",
  deleteExpense: "Bu gideri silmek istediğinizden emin misiniz?",
  expenseDetails: "Gider Detayları",
  expenseReport: "Gider Raporu",
  grandTotalExpense: "Genel Toplam",
  noExpensesYet: "Henüz kayıtlı gider bulunmamaktadır",
  addFirstExpense: "ilk giderinizi eklemek için tıklayın",
  expenseDistribution: "Gider Dağılımı",
  noExpenseData: "Gösterilecek gider verisi bulunmamaktadır",
  itemCount: "adet",
  items: "kalem",
  collapseAll: "Tümünü Daralt",
  expandAll: "Tümünü Genişlet",
  categoryLabel: "Kategori",
  categoryPlaceholder: "Kategori seçin",
  subcategoryLabel: "Alt Kategori",
  subcategoryPlaceholder: "Alt kategori seçin",
  categoryRequired: "Kategori seçimi zorunludur",
  subcategoryRequired: "Alt kategori seçimi zorunludur",
  
  // Gider Kategorileri
  expenseCategories: {
    commonArea: "Ortak Alan & Operasyon",
    maintenance: "Bakım & Onarım",
    management: "Yönetim & Operasyonel",
    taxOfficial: "Vergi & Resmi",
    insurance: "Sigorta & Güvenlik",
    other: "Diğer"
  },
  
  // Gider Alt Kategorileri
  expenseSubcategories: {
    commonArea: {
      cleaning: "Temizlik",
      security: "Güvenlik",
      janitor: "Kapıcı / Personel Maaşı",
      reception: "Resepsiyon / Danışma",
      gardening: "Bahçe Bakımı / Peyzaj",
      elevatorMaintenance: "Asansör Bakımı & Servisi",
      generatorMaintenance: "Jeneratör Bakımı",
      fireSystemsMaintenance: "Yangın Sistemleri Bakımı",
      poolMaintenance: "Havuz Bakımı & Kimyasallar",
      commonElectricity: "Ortak Alan Elektriği",
      commonWater: "Ortak Alan Suyu",
      naturalGas: "Doğalgaz (Ortak Alan)"
    },
    maintenance: {
      electricalRepair: "Elektrik Onarımı",
      plumbingRepair: "Su / Tesisat Onarımı",
      elevatorBreakdown: "Asansör Arızası",
      roofRepair: "Çatı Onarımı",
      paintingRenovation: "Boya & Tadilat",
      fixtureRepair: "Demirbaş Onarımı",
      emergencyRepairs: "Acil Onarımlar"
    },
    management: {
      managerFee: "Yönetici Ücreti",
      accountingAdvisor: "Muhasebe / Mali Müşavir",
      buildingManagementService: "Bina Yönetim Hizmeti",
      legal: "Hukuki / Avukat",
      consultancy: "Danışmanlık",
      stationeryOffice: "Kırtasiye & Ofis",
      softwareSystem: "Yazılım / Sistem"
    },
    taxOfficial: {
      taxes: "Vergiler",
      municipalityFees: "Belediye Harçları",
      licenseProcedures: "Ruhsat & Resmi İşlemler",
      penaltiesFees: "Ceza / Gecikme Ücretleri"
    },
    insurance: {
      buildingInsurance: "Bina Sigortası",
      assetInsurance: "Demirbaş Sigortası",
      occupationalHealth: "İş Sağlığı & Güvenliği",
      fireExtinguisher: "Yangın Söndürücü / Ekipman"
    },
    other: {
      pestControl: "Haşere İlaçlama",
      wasteManagement: "Çöp / Atık Yönetimi",
      snowRemoval: "Kar Temizleme / Mevsimlik",
      generalExpense: "Genel Gider",
      other: "Diğer"
    }
  },
  
  // Announcements
  newAnnouncement: "+ Yeni Duyuru",
  title: "Başlık",
  content: "İçerik",
  latestAnnouncements: "Son Duyurular",
  announcementCreated: "Duyuru oluşturuldu",
  announcementDeleted: "Duyuru silindi",
  deleteAnnouncement: "Bu duyuruyu silmek istediğinizden emin misiniz?",
  noAnnouncements: "Henüz duyuru yok.",
  
  // Announcement Attachments
  attachments: "Ekler",
  addAttachment: "Dosya Ekle",
  fileUploaded: "Dosya yüklendi",
  uploadFailed: "Dosya yüklenemedi",
  fileTooLarge: "Dosya çok büyük. Maksimum 10MB izin verilir.",
  attachmentRemoved: "Ek kaldırıldı",
  removeFailed: "Ek kaldırılamadı",
  downloadFailed: "Dosya indirilemedi",
  allowedFileTypes: "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, GIF, TXT (max 10MB)",
  uploading: "Yükleniyor...",
  creating: "Oluşturuluyor...",
  
  // Settings
  settings: "Ayarlar",
  language: "Dil",
  currency: "Para Birimi",
  settingsUpdated: "Ayarlar güncellendi",
  personalLanguageSetting: "Kişisel dil tercihi",
  systemCurrencySuperAdmin: "Sistem geneli para birimi ayarı",
  systemCurrencyReadOnly: "Sistem geneli para birimi (Sadece Süper Yönetici)",
  onlySuperAdminCanChangeCurrency: "Sadece Süper Yönetici para birimini değiştirebilir",
  noChangesToSave: "Kaydedilecek değişiklik yok",
  
  // Languages
  english: "İngilizce",
  turkish: "Türkçe",
  azerbaijani: "Azerice",
  
  // Users
  users: "Kullanıcılar",
  newUser: "+ Yeni Kullanıcı",
  name: "İsim",
  email: "E-posta",
  phone: "Telefon",
  role: "Rol",
  admin: "Yönetici",
  residentRole: "Sakin",
  userCreated: "Kullanıcı oluşturuldu",
  userUpdated: "Kullanıcı güncellendi",
  editUser: "Kullanıcıyı Düzenle",
  resetPassword: "Şifreyi Sıfırla",
  resetPasswordFor: "Şifre sıfırlama için",
  newPassword: "Yeni Şifre",
  enterNewPassword: "Yeni şifre girin",
  passwordMinLength: "Şifre en az 6 karakter olmalıdır",
  passwordResetSuccess: "Şifre başarıyla sıfırlandı",
  authType: "Kimlik Doğrulama Tipi",
  usernameExists: "Kullanıcı adı zaten mevcut",
  emailOptional: "E-posta (opsiyonel)",
  phoneOptional: "Telefon (opsiyonel)",
  actions: "İşlemler",
  apartmentNo: "Daire No",
  noApartment: "Daire yok",
  apartmentRequired: "Daire gereklidir",
  apartmentRequiredForResident: "Sakin kullanıcılar için daire gereklidir",
  selectApartment: "Daire seçin",
  apartment: "Daire",
  optional: "Opsiyonel",
  
  // SuperAdmin Building Selection
  selectBuilding: "Bina Seç",
  selectedBuilding: "Seçili Bina",
  viewingAsAdmin: "Yönetici Olarak Görüntüleme",
  noBuildingSelected: "Bina seçilmedi",
  viewAdminPanel: "Yönetici Panelini Görüntüle",
  backToSuperAdmin: "Süper Yöneticiye Dön",
  managingBuilding: "Yönetilen Bina",
  
  // Errors
  operationFailed: "İşlem başarısız",
  loadDataFailed: "Veri yüklenemedi",
  authenticationFailed: "Kimlik doğrulama başarısız",
  
  // Misc
  count: "Sayısı",
  totalItems: "Toplam Öğe",
  manageUsers: "Kullanıcıları yönet",
  
  // Months
  months: {
    1: "Ocak",
    2: "Şubat",
    3: "Mart",
    4: "Nisan",
    5: "Mayıs",
    6: "Haziran",
    7: "Temmuz",
    8: "Ağustos",
    9: "Eylül",
    10: "Ekim",
    11: "Kasım",
    12: "Aralık"
  },

  // Resident Portal
  maintenanceStatus: "Aidat Durumu",
  lastSixMonths: "Son 6 Ay",
  paymentReport: "Aidat Raporu",
  unpaidBalance: "Ödenmemiş Bakiye",
  totalPaidLabel: "Toplam Ödenen",
  totalUnpaidMonths: "Toplam Ödenmemiş Ay Sayısı",
  unpaidMonthsCount: "Ödenmemiş Ay Sayısı",
  lastFeeAmount: "Son Aidat Tutarı",
  feeAmount: "Aidat Tutarı",
  payMaintenance: "Aidat Öde",
  viewReportAndPay: "Rapor Görüntüle ve Öde",
  monthTotal: "Aylık Toplam",
  monthShort: {
    1: "Oca",
    2: "Şub",
    3: "Mar",
    4: "Nis",
    5: "May",
    6: "Haz",
    7: "Tem",
    8: "Ağu",
    9: "Eyl",
    10: "Eki",
    11: "Kas",
    12: "Ara"
  },
  recentAnnouncements: "Son Duyurular",
  monthlyExpenses: "Aylık Giderler",
  monthlySummary: "Aylık Mali Özet",
  carryover: "Devir",
  carryoverFromPrevMonth: "Önceki Aydan",
  income: "Gelir",
  expenses: "Gider",
  balance: "Bakiye",
  viewDetailedReport: "Detaylı Raporu Görüntüle",
  year: "Yılı",
  totalIncome: "Toplam Gelir",
  totalExpense: "Toplam Gider",
  netBalance: "Net Bakiye",
  viewReports: "Raporları İncele",
  investments: "Yatırımlar",
  completed: "Tamamlandı",
  inProgress: "Devam Ediyor",
  planned: "Planlandı",
  newInvestment: "+ Yeni Yatırım",
  investmentCreated: "Yatırım oluşturuldu",
  investmentDeleted: "Yatırım silindi",
  deleteInvestment: "Bu yatırımı silmek istediğinizden emin misiniz?",
  noInvestmentsYet: "Henüz kayıtlı yatırım bulunmamaktadır",
  startDate: "Başlangıç Tarihi",
  completedDate: "Tamamlanma Tarihi",
  endDate: "Bitiş Tarihi",
  investmentCategoryLabel: "Yatırım Kategorisi",
  investmentCategoryPlaceholder: "Yatırım kategorisi seçin",
  investmentSubcategoryLabel: "Yatırım Alt Kategorisi",
  investmentSubcategoryPlaceholder: "Yatırım alt kategorisi seçin",
  investmentCategoryRequired: "Yatırım kategorisi seçimi zorunludur",
  investmentSubcategoryRequired: "Yatırım alt kategorisi seçimi zorunludur",
  descriptionRequired: "Açıklama zorunludur",
  endDateBeforeStartDate: "Bitiş tarihi başlangıç tarihinden önce olamaz",
  startDateRequired: "Başlangıç tarihi zorunludur",
  
  // Yatırım Kategorileri
  investmentCategories: {
    physical: "Fiziksel / Yapısal Yatırımlar",
    energy: "Enerji & Verimlilik Yatırımları",
    security: "Güvenlik & Teknoloji",
    social: "Sosyal Alanlar & Konfor",
    legal: "Proje & Hukuki Yatırımlar"
  },
  
  // Yatırım Alt Kategorileri
  investmentSubcategories: {
    physical: {
      elevatorRenovation: "Asansör Yenileme",
      roofRenovation: "Çatı Yenileme / Yalıtım",
      exteriorInsulation: "Dış Cephe Yalıtımı",
      parkingConstruction: "Otopark Yapımı / İyileştirme",
      earthquakeReinforcement: "Deprem Güçlendirme",
      fireSystemInstallation: "Yangın Sistemi Kurulumu",
      waterTankRenovation: "Su Deposu Yenileme",
      generatorInstallation: "Jeneratör Kurulumu"
    },
    energy: {
      solarPanels: "Güneş Panelleri (PV / GES)",
      heatPump: "Isı Pompası",
      ledConversion: "Ortak Alan LED Dönüşümü",
      smartMeterSystems: "Akıllı Sayaç Sistemleri",
      insulationImprovements: "Yalıtım İyileştirmeleri"
    },
    security: {
      cameraSystem: "Kamera Sistemi (CCTV)",
      accessCardSystem: "Kartlı Geçiş Sistemi",
      smartBuildingInfrastructure: "Akıllı Bina Altyapısı",
      intercomRenovation: "Diyafon / Kapı Telefonu Yenileme",
      buildingManagementSoftware: "Bina Yönetim Yazılımı (İlk Kurulum)"
    },
    social: {
      childrensPlayground: "Çocuk Oyun Alanı",
      sportsAreaFitness: "Spor Alanı / Fitness",
      landscapingRenovation: "Peyzaj Yenileme (Tek Seferlik)",
      pergolaSeatingAreas: "Pergola / Çardak / Oturma Alanları",
      commonAreaDecoration: "Ortak Alan Dekorasyon Projeleri"
    },
    legal: {
      architecturalDesign: "Mimari Tasarım Projesi",
      structuralProject: "Yapı (Statik) Projesi",
      municipalityPermit: "Belediye / Ruhsat Bazlı Proje Maliyetleri",
      condominiumTransition: "Kat Mülkiyeti Geçiş Çalışmaları"
    }
  },
  manageInvestments: "Bina projelerini yönet",
  
  // Other Income
  otherIncome: "Diğer Gelirler",
  otherIncomeTitle: "Diğer Gelir Yönetimi",
  manageOtherIncome: "Ek gelir kaynaklarını yönet",
  newOtherIncome: "Yeni Gelir Kaydı",
  addIncome: "+ Gelir Ekle",
  addMaintenancePayment: "+ Aidat Ödemesi Ekle",
  manualPaymentTitle: "Manuel Aidat Ödemesi",
  manualPaymentDescription: "Banka ekstresi olmadan manuel aidat ödemesi girişi",
  selectApartment: "Daire Seç",
  poolAccount: "Havuz Hesabı",
  paymentAmount: "Ödeme Tutarı",
  paymentDate: "Ödeme Tarihi",
  paymentDescription: "Açıklama (İsteğe Bağlı)",
  manualPaymentSuccess: "Ödeme başarıyla kaydedildi",
  manualPaymentError: "Ödeme kaydedilirken hata oluştu",
  processingPayment: "İşleniyor...",
  feesApplied: "aidat ödendi",
  remainingAsCredit: "pozitif bakiye olarak kaydedildi",
  category: "Kategori",
  description: "Açıklama",
  amount: "Tutar",
  date: "Tarih",
  otherIncomeCreated: "Gelir kaydı başarıyla oluşturuldu",
  otherIncomeUpdated: "Gelir kaydı başarıyla güncellendi",
  otherIncomeDeleted: "Gelir kaydı başarıyla silindi",
  editOtherIncome: "Gelir Kaydını Düzenle",
  deleteOtherIncome: "Gelir Kaydını Sil",
  confirmDeleteOtherIncome: "Bu gelir kaydını silmek istediğinizden emin misiniz?",
  
  // Other Income Categories
  incomeCategory: "Gelir Kategorisi",
  commonAreaRental: "Ortak Alan Kirası",
  parkingFees: "Otopark Ücretleri",
  facilityUsageFees: "Tesis Kullanım Ücretleri",
  penalties: "Cezalar / Tazminatlar",
  keyCardFees: "Anahtar / Kart Ücretleri",
  otherCategory: "Diğer",
  
  // Financial Reports
  incomeBreakdown: "Gelir Dağılımı",
  expenseBreakdown: "Gider Dağılımı",
  maintenanceFeeIncome: "Aidat Geliri",
  latePaymentFees: "Gecikme Cezaları",
  otherIncomeTotal: "Diğer Gelirler",
  regularExpenses: "Normal Giderler",
  investmentsTotal: "Yatırımlar",
  totalIncome: "Toplam Gelir",
  netBalance: "Net Bakiye",
  incomeExpenseReport: "Gelir & Gider Raporu",
  viewDetailedReport: "Detaylı Raporu Görüntüle",
  
  // Detailed Report Modal - New Keys
  detailedReportTitle: "Aylık Mali Rapor",
  incomeSectionTitle: "Gelir Detayları",
  aidatIncomeLabel: "Aidat Geliri",
  aidatIncomeNote: "Bu ay ödenen aidatlardan",
  assignedAidatIncomeLabel: "Atanmış Aidat Geliri",
  assignedAidatIncomeNote: "Daireye atanmış aidat ödemeleri",
  pendingPoolIncomeLabel: "Bekleyen Havuz Geliri",
  pendingPoolIncomeNote: "Henüz daireye atanmamış ödemeler",
  otherPaymentIncomeLabel: "Diğer Ödemeler Geliri",
  otherPaymentIncomeNote: "Kapıcı tazminatı vb. daire ödemeleri",
  otherIncomeSectionTitle: "Diğer Gelirler",
  otherIncomeTotalLabel: "Diğer Gelirler Toplamı",
  expensesSectionTitle: "Gider Detayları",
  expenseItemsSectionTitle: "Giderler",
  expensesTotalLabel: "Giderler Toplamı",
  investmentsSectionTitle: "Yatırımlar",
  investmentsTotalLabel: "Yatırımlar Toplamı",
  noIncomeThisMonth: "Bu ay gelir kaydı yok",
  noOtherIncomeThisMonth: "Bu ay diğer gelir yok",
  noExpensesThisMonth: "Bu ay gider kaydı yok",
  noInvestmentsThisMonth: "Bu ay yatırım yok",
  
  // Print
  print: "Yazdır",
  
  // SuperAdmin & Buildings
  superAdminPortal: "Süper Yönetici Portalı",
  buildings: "Binalar",
  buildingManagement: "Bina Yönetimi",
  createBuilding: "Yeni Bina Oluştur",
  editBuilding: "Binayı Düzenle",
  buildingName: "Bina Adı",
  buildingAddress: "Bina Adresi",
  numberOfFloors: "Kat Sayısı",
  numberOfApartments: "Toplam Daire",
  buildingAdmin: "Bina Yöneticisi",
  adminFullName: "Yönetici Adı Soyadı",
  adminUsername: "Yönetici Kullanıcı Adı",
  adminPassword: "Yönetici Şifresi",
  adminPhone: "Yönetici Telefon",
  adminEmail: "Yönetici E-posta",
  buildingCreated: "Bina başarıyla oluşturuldu",
  buildingUpdated: "Bina başarıyla güncellendi",
  buildingDeleted: "Bina başarıyla silindi",
  viewBuilding: "Binayı Görüntüle",
  deleteBuilding: "Binayı Sil",
  confirmDeleteBuilding: "Bu binayı silmek istediğinizden emin misiniz?",
  buildingDetails: "Bina Detayları",
  manageBuildings: "Binaları ve yöneticileri yönet",
  noBuildings: "Henüz bina yok",
  leaveBlankToKeep: "Mevcut şifreyi korumak için boş bırakın",
  
  // Change Password
  changePassword: "Şifre Değiştir",
  currentPassword: "Mevcut Şifre",
  newPassword: "Yeni Şifre",
  confirmNewPassword: "Yeni Şifreyi Onayla",
  passwordChangedSuccess: "Şifreniz başarıyla değiştirildi",
  currentPasswordIncorrect: "Mevcut şifre yanlış",
  passwordsDoNotMatch: "Şifreler eşleşmiyor",
  passwordTooWeak: "Şifre en az 6 karakter olmalıdır",
  newPasswordSameAsOld: "Yeni şifre mevcut şifreden farklı olmalıdır",
  enterCurrentPassword: "Mevcut şifrenizi girin",
  enterNewPassword: "Yeni şifrenizi girin",
  confirmPassword: "Yeni şifrenizi onaylayın",
  passwordChangeError: "Şifre değiştirilemedi. Lütfen tekrar deneyin.",
  
  // Payment Status Modal
  paymentStatusTitle: "Aidat Ödeme Durumu",
  previousYearBalance: "Önceki Yıldan Gelen Bakiye",
  carryOverDebt: (year) => `${year} yılından devreden borç bakiyesi`,
  payUnpaidFees: "Ödenmemiş Aidatları Öde",
  paySelectedUnpaidFees: "Seçilen Aidatları Öde",
  devir: "Devir Bakiyesi",
  devirDesc: "Önceki yıldan devreden bakiye",
  partiallyPaid: "Kısmi Ödendi",
  paidAmount: "Ödenen",
  remainingAmount: "Kalan",
  otherPaymentLabel: "Diğer Ödeme",
  cumulativeBalance: "Kümülatif Kalan",
  collapseYear: "Yılı daralt",
  expandYear: "Yılı genişlet",
  paymentDate: "Ödeme Tarihi",
  selectPaymentDate: "Ödeme Tarihi Seçin",
  noFeesFound: "Henüz aidat kaydı bulunmamaktadır.",
  paymentSummaryTitle: "Ödeme Özeti",
  paymentSummaryDescription: "Ödeme yapmadan önce seçili aidatları gözden geçirin",
  confirmPayment: "Ödemeyi Onayla",
  cancelPayment: "İptal",
  selectedTotal: "Seçilen Toplam",
  monthsToPay: "Ödenecek Aylar",
  totalAidat: "Toplam Aidat",
  totalOtherPayment: "Toplam Diğer Ödeme",
  totalPaid: "Toplam Ödenen",
  totalRemaining: "Toplam Kalan",
  makePayment: "Ödeme Yap",
  paymentAmountLabel: "Ödeme Tutarı",
  paymentAmountExceedsDebt: "Ödeme tutarı toplam borçtan fazla olamaz",
  paymentAmountMustBePositive: "Ödeme tutarı pozitif olmalıdır",
  totalDebt: "Toplam Borç",
  maintenanceFee: "Aidat",
  otherPaymentCol: "Diğer Ödeme",
  paidAmountCol: "Ödenen",
  remainingCumulative: "Kalan (Küm.)",
  yearSummary: "Yıl Özeti",
  
  // Bank Statement Name Matching
  matchStatistics: "Eşleşme İstatistikleri",
  byUnitNumber: "Daire No ile",
  byFullName: "Tam İsim ile",
  bySimilarName: "Benzer İsim ile",
  needsReview: "İnceleme Gerekli",
  dataConflicts: "Veri Çakışması",
  matchType: "Eşleşme Tipi",
  matchedByUnitNumber: "Daire numarasına göre eşleşti",
  matchedByFullName: "Tam isim eşleşmesi",
  matchedBySimilarName: "Benzer isim eşleşmesi",
  lowConfidence: "Düşük Güven",

  // WhatsApp Templates
  waTemplateDuesReminder: "Aidat Hatırlatma",
  waTemplateDuesReminderDesc: "Sakinlere ödenmemiş aidat bildirimi gönderir",
  waTemplateDuesReminderBody: "Sayın {{residentName}}, {{apartmentNumber}} numaralı dairenizin ödenmemiş aidat borcu {{amount}} tutarındadır. Lütfen ödemenizi gerçekleştiriniz.",
  waTemplateAnnouncementGeneral: "Genel Duyuru",
  waTemplateAnnouncementGeneralDesc: "Genel bina duyurusu gönderir",
  waTemplateAnnouncementGeneralBody: "Yeni duyuru: {{announcementText}}",
  waTemplateVarResidentName: "Sakin Adı",
  waTemplateVarApartmentNumber: "Daire Numarası",
  waTemplateVarAmount: "Tutar",
  waTemplateVarAnnouncementText: "Duyuru Metni",
  waPageTitle: "WhatsApp",
  waPageSubtitle: "Sakinlere bildirim gönderin",
  waSendTab: "Mesaj Gönder",
  waLogTab: "Mesaj Geçmişi",
  waTemplatesTab: "Şablonlar",
  waTemplateMode: "Şablon",
  waTextMode: "Serbest Metin",
  waRecipientPhone: "Alıcı Telefon",
  waMessageBody: "Mesaj",
  waTextPlaceholder: "Mesajınızı yazın...",
  waSelectTemplate: "Şablon",
  waLanguage: "Dil",
  waVariables: "Değişkenler",
  waPreview: "Önizleme",
  waSendBtn: "WhatsApp Mesajı Gönder",
  waSending: "Gönderiliyor...",
  waPhoneRequired: "Telefon numarası gereklidir",
  waMessageRequired: "Mesaj gereklidir",
  waFillAllVars: "Tüm şablon değişkenlerini doldurun",
  waMessageSent: "Mesaj gönderildi",
  waTemplateSent: "Şablon mesajı gönderildi",
  waError: "Hata",
  waTextWarning: "Serbest metin mesajları yalnızca son 24 saat içinde işletmenize mesaj göndermiş alıcılara iletilir. İlk mesajlar için şablon kullanın.",
  waResidents: "Telefonlu Sakinler",
  waNoResidents: "Telefon numarası olan sakin bulunamadı",
  waNoMessages: "Henüz mesaj gönderilmedi",
  waDate: "Tarih",
  waRecipient: "Alıcı",
  waType: "Tür",
  waContent: "İçerik",
  waStatus: "Durum",
  waSentBy: "Gönderen",
  waNavDesc: "Bildirim gönder"
};
